import vue from "vue";
import VueRouter from "vue-router";
vue.use(VueRouter);

// 导航到当前路由报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  // pc
  {
    path: "/",
    redirect: "home",
  },
  {
    path: "/home",
    component: () => import("@/views/home"),
    meta: {
      keepAlive: true, // 需要缓存
    },
  },
  {
    path: "/info",
    component: () => import("@/views/info"),
  },
  {
    path: "/pay",
    component: () => import("@/views/pay"),
  },
  {
    path: "/detail",
    component: () => import("@/views/detail"),
  },
  {
    path: "/policy",
    component: () => import("@/views/policy"),
  },
  {
    path: "/error",
    component: () => import("@/views/error"),
  },
  {
    path: "*",
    component: () => import("@/views/404"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
